// extracted by mini-css-extract-plugin
module.exports = {"root":"UpdatePassword__root--1FHKZ Layout__form--4yOS_"};